import * as React from 'react';
import {
   Slider,
   SliderProps,
   SliderMark,
   SliderTrack,
   SliderFilledTrack,
   SliderThumb,
   Tooltip,
} from '@chakra-ui/react';

const sliderMarkStyles = {
   color: 'blueGray.600',
   mt: 4,
   ml: '-2.5',
   fontSize: 'sm',
};

type CustomSliderProps = { value: number; onChange: (val: number) => void } & SliderProps;

export function CustomSlider({ value, onChange, ...props }: CustomSliderProps) {
   const [showTooltip, setShowTooltip] = React.useState(false);

   return (
      <Slider
         value={value}
         onChange={val => onChange(val)}
         onMouseEnter={() => setShowTooltip(true)}
         onMouseLeave={() => setShowTooltip(false)}
         step={5}
         mt={3}
         mb={6}
         {...props}
      >
         <SliderMark value={0} {...sliderMarkStyles} ml={-1}>
            Min
         </SliderMark>
         <SliderMark value={25} {...sliderMarkStyles}>
            25%
         </SliderMark>
         <SliderMark value={50} {...sliderMarkStyles}>
            50%
         </SliderMark>
         <SliderMark value={75} {...sliderMarkStyles}>
            75%
         </SliderMark>
         <SliderMark value={100} {...sliderMarkStyles} ml={-5}>
            Max
         </SliderMark>
         <SliderTrack h="6px">
            <SliderFilledTrack />
         </SliderTrack>
         <Tooltip
            hasArrow
            color="white"
            placement="top"
            isOpen={showTooltip}
            label={`${value}%`}
            aria-label={`${value}%`}
         >
            <SliderThumb />
         </Tooltip>
      </Slider>
   );
}
